export const PREAMBLE_TYPE_REQUEST = 'PREAMBLE_TYPE_REQUEST';
export const PREAMBLE_TYPE_SUCCESS = 'PREAMBLE_TYPE_SUCCESS';
export const PREAMBLE_TYPE_FAIL = 'PREAMBLE_TYPE_FAIL';

